/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { PhoneCommunicationDto } from '../../../../../apps/myprofile-ui/src/app/services/phone/phone.service'

export class SetEditorLoadingStatus {
  static readonly type = '[phone-editor] set editor loading status'

  constructor(public loading: boolean) {}
}

export class ShowBlankEditor {
  static readonly type = '[phone-editor] show blank editor'
  constructor(public visible: boolean) {}
}

export class CreatePhone {
  static readonly type = '[phone-editor] create phone'

  constructor(public phone: PhoneCommunicationDto) {}
}

export class UpdatePhone {
  static readonly type = '[phone-editor] update phone'

  constructor(public phone: PhoneCommunicationDto) {}
}

export class DeletePhone {
  static readonly type = '[phone-editor] delete phone'
  constructor(public phone: PhoneCommunicationDto) {}
}

export class UpdateTmpPhone {
  static readonly type = '[phone-editor] update tmp phone'
  constructor(public payload: any) {}
}

export class SetEditorErrorMessage {
  static readonly type = '[phone-widget] set Error Message'

  constructor(public errorMessage: string) {}
}
